<template>
  <div class="pages">
    <navTop></navTop>
    <div class="box">
      <!-- 照片 -->
      <div class="photo">
        <p class="photo-top">Photo uploaded by inspector</p>
        <img class="photo-img" src="../../assets/orderDetails-main-img.png" />
        <div class="imgs"><img :src="item" v-for="(item, index) in lists" :key="index" /></div>
      </div>
    </div>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import navFooter from '../../components/navFooter.vue';
export default {
  name: 'see',
  components: {
    navTop,
    navFooter
  },
  data() {
    return {
      lists: []
    };
  },
  created() {
    if (!sessionStorage.getItem('uid')) {
      this.$router.push({path: '/'});
    } else {
      this.lists = this.$route.query.arrivePic ? this.$route.query.arrivePic.split('|') : [];
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    margin: 30px auto 80px;
    max-width: 1400px;
    padding: 0 20px;
    position: relative;
    z-index: 2;
    box-sizing: border-box;

    // 照片
    .photo {
      width: 100%;
      border-radius: 45px;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      border: 1px solid $blue-primary-rgba;
      box-shadow: 0 0 40px $blue-glow;
      padding: 50px 60px 70px;
      box-sizing: border-box;

      .photo-top {
        font-size: 36px;
        color: $blue-primary;
        line-height: 1.2em;
        text-align: center;
        text-shadow: $text-glow;
        margin-bottom: 20px;
      }

      .photo-img {
        width: 100%;
        height: 2px;
        display: block;
        margin: 20px 0;
        background: linear-gradient(90deg, transparent, $blue-primary, transparent);
        border: none;
      }

      .imgs {
        padding: 40px 20px 0;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        gap: 25px;
        justify-content: flex-start;

        img {
          width: calc(33.333% - 17px);
          min-width: 280px;
          height: 280px;
          border-radius: 16px;
          display: block;
          margin-right: 0;
          margin-bottom: 0;
          object-fit: cover;
          border: 2px solid $blue-primary;
          box-shadow: 0 0 25px $blue-glow;
          transition: all 0.3s ease;

          &:hover {
            transform: scale(1.02);
            box-shadow: 0 0 35px $blue-primary;
            border-color: lighten($blue-primary, 10%);
          }
        }
      }
    }
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .box {
      .photo {
        padding: 40px 30px 50px;

        .photo-top {
          font-size: 28px;
        }

        .imgs {
          padding: 30px 10px 0;
          gap: 20px;

          img {
            width: calc(50% - 10px);
            min-width: 240px;
            height: 240px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    .box {
      .photo {
        padding: 30px 20px 40px;

        .photo-top {
          font-size: 24px;
        }

        .imgs {
          padding: 20px 0 0;
          gap: 15px;

          img {
            width: 100%;
            height: 200px;
          }
        }
      }
    }
  }
}
</style>